<div id="heroVideoDiv">
  <div id="videoDiv">
    <div class="bgOverlay"></div>
    <video
      loop
      muted
      autoplay
      playsinline
      id="video"
      >
      <source src="../../../assets/video/Herovideo.mp4" type="video/mp4" />
    </video>
  </div>
  <div id="messageBox" class="row">
    <div class="hero-text">
      @if (pageContent) {
        <div class="col-lg-6 col-md-9 col-sm-12 caption">
          <h1 class="h1Size">
            {{ pageContent.title }}
          </h1>
          <br />
          <div
            [innerHTML]="pageContent.body"
            id="innerText"
            class="col-lg-9 col-md-9 col-sm-12 pb-5"
          ></div>
        </div>
      }
    </div>
  </div>
</div>
